module.exports = __webpack_public_path__ + "img/version.aa5ba074.png";